import { render, staticRenderFns } from "./CameraCaptureDialog.vue?vue&type=template&id=20fc926c&"
import script from "./CameraCaptureDialog.vue?vue&type=script&lang=js&"
export * from "./CameraCaptureDialog.vue?vue&type=script&lang=js&"
import style0 from "./CameraCaptureDialog.vue?vue&type=style&index=0&id=20fc926c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QFab from 'quasar/src/components/fab/QFab.js';
import QFabAction from 'quasar/src/components/fab/QFabAction.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QFab,QFabAction,QPageSticky,QBtn,QSpinnerFacebook});
